import Modal from 'react-modal';
import PropTypes from 'prop-types';
import "../../../styles/AdminPage.css";
import TextInput from '../../inputs/TextInput';
import React , {useEffect, useState} from 'react';
import { createEventType, updateEventType } from '../../../api/admin/AdminSettingsAPI';
import InputContainer from './InputContainer';
import AdminSettingsEditModal from './AdminSettingsEditModal';
import toast from 'react-hot-toast';

Modal.setAppElement('#root');

const EditEventTypeModal = ({ isOpen, onClose, isAdding, item, setItems }) => {    
    const [eventTypeName, setEventTypeName] = useState("");

    useEffect(() => {
        if (!isAdding && item) {
            setEventTypeName(item.eventType);
        }
    }, [isAdding, item]);

    const modalTitle = isAdding ? "Add Event Type" : "Edit Event Type";

    const handleConfirm = async () => {
        let data;

        if (isAdding){
            data = {
                eventType: eventTypeName
            };

            try {
                toast.loading("Creating Event Type...");
                const response = await createEventType(data);
                setTimeout(async () => {
                    if (response.ok) {
                        toast.dismiss();
                        try {
                            const newEventType = await response.json();
                            toast.success("Event Type created!");
                            setItems((prev) => [...(prev ?? []), newEventType]);
                            onClose();
                        } catch (jsonError) {
                            console.error("Error parsing JSON:", jsonError);
                            toast.error("Error parsing server response.");
                        }
                    } else {
                        toast.dismiss();
                        console.log("Error creating Event Type. Status:", response.status);
                        toast.error("Event Type failed to create. Status: " + response.status);
                    }
                    
                }, 500);
            } catch (error) {
                toast.dismiss();
                console.error("Error submitting Event Type:", error);
                alert("Something went wrong. Please check your connection and try again.");

            }
        } else {
            data = {
                id: item.id,
                eventType: eventTypeName
            };

            try {
                toast.loading("Updaing Event Type...");
                const response = await updateEventType(data);
                setTimeout(async () => {
                        if (response.ok) {
                            toast.dismiss();
                            try {
                                toast.success("Event Type updated!");
                                setItems((prev) => (prev ?? []).map(e => e.id === item.id ? data : e));
                                onClose();
                            } catch (jsonError) {
                                console.error("Error parsing JSON:", jsonError);
                                toast.error("Error parsing server response.");
                            }
                        } else {
                            toast.dismiss();
                            console.log("Error updating requirement. Status:", response.status);
                            toast.error("Event Type failed to create. Status: " + response.status);
                        }
                }, 500);
            } catch (error) {
                toast.dismiss();
                console.error("Error submitting requirement:", error);
                alert("Something went wrong. Please check your connection and try again.");

            }

        }
    };

    const content = (
        <>
            <InputContainer>
                <TextInput
                    id="swag-name"
                    placeholder="Enter Event Type"
                    label='Event Type'
                    className="edit-swag-text form-input"
                    value={eventTypeName}
                    setValue={(e) => setEventTypeName(e.target.value)}
                />
            </InputContainer>
        </>
    )

    return (
       <AdminSettingsEditModal
            modalTitle={modalTitle}
            content={content}
            isOpen={isOpen}
            onClose={onClose}
            handleConfirm={handleConfirm}
       />
    );
};

EditEventTypeModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
};

export default EditEventTypeModal;